export const env = {
  api_url: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8100/api',
  re_captcha_key: process.env.NEXT_PUBLIC_RE_CAPTCHA_KEY || '',
  site_url:
    process.env.NEXT_PUBLIC_SITE_URL ?? process.env.NODE_ENV === 'development'
      ? 'https://storefront-dev.lentho.com'
      : 'https://lentho.com',
  activeHostedEmbedURL: process.env.NEXT_PUBLIC_ACTIVE_HOSTED_EMBED_URL,
};

export const storage_keys = {
  locale: '4TA_LOCALE',
  customer_token: '4TA_CUSTOMER_TOKEN',
  customer_refresh_token: '4TA_CUSTOMER_REFRESH_TOKEN',
  customer_profile: '4TA_CUSTOMER_PROFILE',
  customer_cart: '4TA_CART',
  restaurant_token: '4TA_RESTAURANT_TOKEN',
  restaurant_refresh_token: '4TA_RESTAURANT_REFRESH_TOKEN',
  restaurant_profile: '4TA_RESTAURANT_PROFILE',
  admin_profile: '4TA_ADMIN_PROFILE',
  admin_token: '4TA_ADMIN_TOKEN',
  impersonate_id: '4TA_IMP_ID',
  res_impersonate_id: '4TA_RES_IMP_ID',
  restaurant_lang: 'res_ln',
  res_profile_bnfc: 'res_profile_banner_nfc',
  restaurant_dashboard_bnfc: 'restaurant_dashboard_bnfc',
  res_employee_dashboard_bnfc: 'res_employee_dashboard_bnfc',
  res_driver_dashboard_bnfc: 'res_driver_dashboard_bnfc',
  storefront_homepage_bnfc: 'storefront_homepage_bnfc',
  banner_notifications: 'banner_notifications',
  last_restaurant_notification: 'last_restaurant_notification',
  last_customer_notification: 'last_customer_notification',
  res_token: 'srv_res_token',
  firebase_device_token: 'firebase_device_token',
  last_failed_order: 'last_failed_order',
  show_failed_order_popup: 'show_failed_order_popup',
  customer_referral_code: 'LENTHO_CUSTOMER_REFERRAL_CODE',
  referral_search_param: 'referral',
  registration_completion_token: 'registration_completion_token',
};

export const defaultFormLocale = 'en';

export const formLocales = ['de', 'en'];

export const restaurantBasePath = `/business/dash`;

export const notificationType: any = {
  'App\\Notifications\\RestaurantNewOrder': 'New order placed',
  'App\\Notifications\\RestaurantReviewPosted': 'New review posted.',
  'App\\Notifications\\RestaurantOrderCancelRequest':
    'Requested for order cancel',
  'App\\Notifications\\RestaurantOrderUpdate': 'Updated order',
};

export const APP_BRAND_NAME = 'LENTHO';
export const BRAND_LOGO_ALT_TEXT = `${APP_BRAND_NAME} logo`;

export const parentTagSwiperID = 'parent_tag';
export const childTagSwiperID = 'child_tag';

export const SHOP_TYPES = {
  online_shop: 'online_shop',
  restaurant: 'restaurant',
};
